Namespace 'Customer.Ticket'

class Customer.Ticket.WebchatHistoryView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/webchat/webchat_history']
  className: 'webchat-history-container'
  events:
    'click .wh-footer': '_toggleHistory'

  initialize: ({history}) ->
    @history = history

  render: ->
    @$el.html @template()
    @$('.wh-messages').append @_historyMessageView(message).render().el for message in @history.models
    @

  _historyMessageView: (message) ->
    new Customer.Ticket.WebchatHistoryMessageView
      historyMessage: message

  _toggleHistory: ->
    @$('.wh-arrow').toggleClass 'fa-chevron-up fa-chevron-down'
    @$('.wh-messages, .wh-messages-line').slideToggle()
